<script>
    import Button from 'views/components/button/Button.svelte';
    import ContentLabel from 'views/components/contentLabel/ContentLabel.svelte';
    import {getAttainableTestScoreForChapter, getScanAdvice, getScanChapters, getScoreForChapter} from 'util/activityUtil/ScanUtil'
    import UnfinishedTasksCard from 'views/pages/activities/show/types/exam/summary/UnfinishedTasksCard.svelte';
    import Icon from 'views/components/icon/Icon.svelte';
    import ResultRing from 'views/components/resultRing/ResultRing.svelte';

    const {
        isStart,
        model,
        isStudentExamMode,
        isStudentExamClosedMode,
        isStudentReviewAnswersMode,
        navigationBar,
    } = $props()

    // svelte-ignore state_referenced_locally
    const unfinishedTasks = model.getUnfinishedTasks()

    function gotoParentSection() {
        Backbone.history.navigate(`/sections/show/${model.get('section_id')}`, {trigger: true})
    }

    function handInTest() {
        Backbone.View.layout.openConfirmStatus(
            window.i18n.sprintf(window.i18n.gettext(
                'If you hand in this %s you can no longer edit your answers. Are you sure you\'re finished?'
            ), model.getActivityTypeLabel().toLowerCase()),
            () => model.handInTest(() => {
                // After hand in, reload the activity so that results are shown
                Backbone.history.loadUrl()
            }),
            () => {},
            window.i18n.gettext('Hand in'),
        )
    }
</script>

{#snippet activityTitle()}
    <h1>{model.get('name')} <span class="scan-level">{model.get('scan').metadata.level}</span></h1>
{/snippet}

{#if ACL.checkRole(ACL.roles.TEACHER) || (isStudentExamMode && isStart)}
    {#if isStart}
        <header>
            {@render activityTitle()}
            {window.i18n.gettext('This scan is about the following chapters')}:
        </header>
        <div class="chapters">
            {#each getScanChapters(model) as chapter (chapter.id)}
                <ContentLabel
                    model={chapter}
                    isOnBackground={true}
                ></ContentLabel>
            {:else}
                {window.i18n.gettext('No sections have been selected')}
            {/each}
        </div>
        <header>{window.i18n.sprintf(
            window.i18n.ngettext('%d task group', '%d task groups', model.task_groups.length),
            model.task_groups.length
        )}</header>
        <Button
            label={window.i18n.gettext('Begin')}
            iconRight="arrow-right"
            size="medium"
            callback={() => navigationBar.toNextItem()}
        ></Button>
    {:else}
        <header>
            {@render activityTitle()}
            {window.i18n.sprintf(window.i18n.gettext('End of %s'), model.getActivityTypeLabel().toLowerCase())}
        </header>
        <Button
            label={window.i18n.gettext('Done')}
            icon="cross"
            size="medium"
            callback={gotoParentSection}
        ></Button>
    {/if}
{:else if isStudentExamMode && !isStart}
    {#if unfinishedTasks.length}
        <header>
            {window.i18n.sprintf(window.i18n.gettext('End of %s'), model.getActivityTypeLabel().toLowerCase())}<br />
            {window.i18n.sprintf(window.i18n.ngettext(
                'You haven\'t answered %s task.',
                'You haven\'t answered %s tasks.',
                unfinishedTasks.length
            ), unfinishedTasks.length)}
        </header>
        <UnfinishedTasksCard
            {unfinishedTasks}
            activityModel={model}
            {navigationBar}
        ></UnfinishedTasksCard>
        <div class="actions">
            <Button
                label={window.i18n.gettext('Go back')}
                icon="restart"
                size="medium"
                callback={() => navigationBar.revertActiveItem()}
            ></Button>
            <Button
                label={window.i18n.gettext('Hand in incomplete')}
                icon="take-in"
                size="medium"
                theme="danger"
                callback={handInTest}
            ></Button>
        </div>
    {:else}
        <header>
            {window.i18n.sprintf(window.i18n.gettext('End of %s'), model.getActivityTypeLabel().toLowerCase())}<br />
            {window.i18n.sprintf(window.i18n.gettext('Hand in this %s when you are finished'), model.getActivityTypeLabel().toLowerCase())}
        </header>
        <div class="actions">
            <Button
                label={window.i18n.gettext('Hand in')}
                icon="take-in"
                size="medium"
                theme="primary"
                callback={handInTest}
            ></Button>
        </div>
    {/if}
{:else if isStudentExamClosedMode}
    <header>
        {window.i18n.sprintf(window.i18n.gettext('End of %s'), model.getActivityTypeLabel().toLowerCase())}
        {@render activityTitle()}
    </header>
    <div class="scan-test-result-advice">
        {const scanAdvice = getScanAdvice(model)}
        <div class="advice-label">
            <h2>{window.i18n.gettext('Advice')}</h2>
            <h2>{scanAdvice.label}</h2>
        </div>
        <ResultRing
            value={scanAdvice.score / scanAdvice.attainableScore}
            label={`${scanAdvice.score.toLocaleString(undefined, {maximumFractionDigits: 1})}/${scanAdvice.attainableScore}`}
            color={scanAdvice.color}
            size={100}
            subLabel={window.i18n.ngettext('point', 'points', scanAdvice.attainableScore)}
        ></ResultRing>
    </div>
    <details class="scan-test-result-details">
        <summary>
            <Icon name="arrow-down"></Icon>
            {window.i18n.gettext('Details')}
        </summary>

        <div class="scan-test-result-chapters">
            {#each getScanChapters(model) as chapter (chapter.id)}
                {const attainableScore = getAttainableTestScoreForChapter(model, chapter.id)}
                {const score = getScoreForChapter(model, chapter.id)}
                <ContentLabel model={chapter} isOnBackground={true}></ContentLabel>
                <span>{window.i18n.sprintf(
                    window.i18n.gettext('%s of %s points'),
                    score.toLocaleString(undefined, { maximumFractionDigits: 1 }),
                    attainableScore.toLocaleString(undefined, { maximumFractionDigits: 1 })
                )}</span>
            {/each}
        </div>
    </details>
    {#if isStudentReviewAnswersMode && isStart}
        <Button
            label={window.i18n.gettext('Review')}
            iconRight="arrow-right"
            size="medium"
            callback={() => navigationBar.toNextItem()}
        ></Button>
    {:else}
        <Button
            label={window.i18n.gettext('Done')}
            icon="cross"
            size="medium"
            callback={gotoParentSection}
        ></Button>
    {/if}
{/if}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
header {
  font-size: 16px;
  text-align: center;
}
header h1 {
  font-size: 26px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
header .scan-level {
  font-size: 14px;
  font-weight: 400;
  padding: 4px 12px;
  background-color: rgb(91.76%, 94.84%, 97.04%);
  color: hsl(205, 60%, 44%);
  border-radius: 12px;
  vertical-align: middle;
}

.chapters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 260px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 16px;
}

.actions {
  display: flex;
  gap: 16px;
}

.scan-test-result-advice,
details.scan-test-result-details {
  min-width: 480px;
}

.scan-test-result-advice {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
}
.scan-test-result-advice .advice-label {
  margin: auto 0;
}
.scan-test-result-advice h2 {
  margin-block: 0.5em;
}

details.scan-test-result-details {
  gap: 8px 16px;
  min-width: 480px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 16px;
}
details.scan-test-result-details summary {
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
}
details.scan-test-result-details summary :global(svg) {
  height: 1.5em;
  fill: currentColor;
}
details.scan-test-result-details .scan-test-result-chapters {
  display: grid;
  gap: 8px;
  grid-template-columns: auto 0.4fr;
  padding: 0 16px 16px 16px;
}
details.scan-test-result-details[open] summary :global(svg) {
  transform: rotate(180deg);
}</style>
